<p-toast></p-toast>

<div class="photo-viewer-container" [class.photo-viewer-container--embedded]="embedded()">
  <!-- Header Bar -->
  @if (!embedded()) {
  <div class="photo-viewer-header">
    <div class="header-left">
      <button class="btn-back" type="button" (click)="goBackToPhotos()">
        <i class="ri-arrow-left-line"></i>
        <span>{{ isReadOnly ? 'Check Sheet' : 'All Photos' }}</span>
      </button>
    </div>

    <div class="header-center">
      <h3 class="photo-title">{{ currentPhoto?.photoName || 'Loading...' }}</h3>
      <span class="page-info">{{ currentPageInfo }}</span>
    </div>

    <div class="header-right">
      <button class="btn-outline" type="button" (click)="openDownloadMenu($event, downloadMenu)" [disabled]="!currentPhoto || isDownloading">
        <i class="ri-download-line"></i>
        <span>Download</span>
      </button>
      <p-menu #downloadMenu [model]="downloadMenuItems" [popup]="true" appendTo="body"></p-menu>
    </div>
  </div>

  <div class="photo-metadata-bar">
    <div class="metadata-item">
      <span class="metadata-label">Uploaded By</span>
      <span class="metadata-value">{{ uploadedByDisplay }}</span>
    </div>
    <div class="metadata-item">
      <span class="metadata-label">Captured At</span>
      <span class="metadata-value">{{ capturedAtDisplay }}</span>
    </div>
    <div class="metadata-item">
      <span class="metadata-label">Latitude</span>
      <span class="metadata-value">{{ latitudeDisplay }}</span>
    </div>
    <div class="metadata-item">
      <span class="metadata-label">Longitude</span>
      <span class="metadata-value">{{ longitudeDisplay }}</span>
    </div>
    <div class="metadata-item">
      <span class="metadata-label">Source</span>
      <span class="metadata-value">{{ sourceDisplay }}</span>
    </div>
  </div>
  }

  <!-- WebViewer Container -->
  <div class="webviewer-wrapper">
    @if (isLoading) {
      <div class="loading-overlay">
        <i class="ri-loader-4-line loading-spinner"></i>
        <p class="loading-text">Loading photo...</p>
      </div>
    }
    <div #viewerContainer class="webviewer-container"></div>
  </div>

  <!-- Navigation Buttons -->
  @if (hasPreviousPhoto) {
    <button class="nav-button nav-prev" type="button" (click)="goToPreviousPhoto()" title="Previous Photo">
      <i class="ri-arrow-left-s-line"></i>
    </button>
  }

  @if (hasNextPhoto) {
    <button class="nav-button nav-next" type="button" (click)="goToNextPhoto()" title="Next Photo">
      <i class="ri-arrow-right-s-line"></i>
    </button>
  }
</div>
